import { render, staticRenderFns } from "./otherGraph.vue?vue&type=template&id=0ca2ed11&scoped=true&"
import script from "./otherGraph.vue?vue&type=script&lang=js&"
export * from "./otherGraph.vue?vue&type=script&lang=js&"
import style0 from "./otherGraph.vue?vue&type=style&index=0&id=0ca2ed11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2ed11",
  null
  
)

export default component.exports